<template>
  <div>
  <WaitingForParts :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></WaitingForParts>
</div>
</template>

<script>
import WaitingForParts from "../../components/WaitingForParts-ColumnAlpha.vue";
import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    WaitingForParts,
    highcharts: Chart
  }
};
</script>
